import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    dialog: { type: String, default: "#dialog-shell" },
    title: { type: String, default: "" },
    size: { type: String, default: "" },
    mobile: { type: String, default: "" },
    closedby: { type: String, default: "" }
  };

  get dialogElement() {
    return document.querySelector(this.dialogValue);
  }

  get dialogController() {
    return this.application.getControllerForElementAndIdentifier(this.dialogElement, "dialog");
  }

  open(event) {
    event.preventDefault();
    const dialog = this.dialogElement;
    const ctrl = this.dialogController;

    if (dialog && ctrl) {
      ctrl.closeOtherModals();
      this.configure(dialog, ctrl);
      ctrl.setFrameSrc(this.element.href);
      ctrl.loadLazyFrames();

      if (!dialog.open) dialog.showModal();
    }
  }

  // The shell names itself through aria-labelledby on its heading, so filling
  // that heading is the whole job — an aria-label here would lose to it anyway.
  // The title attribute is the older path and still works, but it paints a
  // native tooltip the caller never asked for; prefer the value.
  configure(dialog, ctrl) {
    ctrl.setTitle(this.titleValue || this.element.title || "");

    if (this.sizeValue) {
      dialog.dataset.size = this.sizeValue;
    } else {
      delete dialog.dataset.size;
    }

    if (this.mobileValue) {
      dialog.dataset.mobile = this.mobileValue;
    } else {
      delete dialog.dataset.mobile;
    }

    // Clearing it rather than writing a default of our own leaves one default in
    // the system: dialog_controller reads a missing attribute as closerequest.
    if (this.closedbyValue) {
      dialog.setAttribute("closedby", this.closedbyValue);
    } else {
      dialog.removeAttribute("closedby");
    }
  }
}
